import { Component, input, OnChanges, OnInit, output, SimpleChanges } from '@angular/core';
import { ICategoryItem } from '@shared/constants/models.const';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { ButtonComponent } from '@shared/components/button/button.component';
import { ResponsivityService } from '../../../services/responsivity.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-categories-mobile',
  imports: [
    MatCheckbox,
    TranslateModule,
    ButtonComponent,
    AsyncPipe,
  ],
  templateUrl: './categories-mobile.component.html',
  styleUrl: './categories-mobile.component.scss',
})
export class CategoriesMobileComponent implements OnInit, OnChanges {
  list = input.required<ICategoryItem[]>();
  selectedCount = input<number>(0);

  isAllChecked: boolean = true;
  isSomeChecked: boolean = true;

  categoriesEmitter = output<ICategoryItem[]>();
  categoriesList: ICategoryItem[] = [];
  isMobileCategoriesOpen: boolean = false;
  isOpenSubject!: BehaviorSubject<boolean>;

  selectedCategoriesCount = 0;

  protected readonly BUTTON_TYPES = BUTTON_TYPES;

  constructor(private responsivityService: ResponsivityService) {
  }


  ngOnInit() {
    this.isOpenSubject = this.responsivityService.isCategoriesOpen;
    this.responsivityService.isCategoriesOpen
      .pipe(untilDestroyed(this))
      .subscribe(data => this.isMobileCategoriesOpen = data);
    this.resetList();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.resetList();
  }

  resetList(): void {
    this.categoriesList = JSON.parse(JSON.stringify(this.list()));
    this.selectedCategoriesCount = this.selectedCount();
    this.updateAllChecked();
  }

  updateAllChecked() {
    this.isSomeChecked = this.categoriesList.some(item => item.checked);
    this.isAllChecked = this.categoriesList.every(item => item.checked);
    let sum = 0;
    this.categoriesList.map(item => {
      if (item.checked) {
        sum++;
      }
    });
    this.selectedCategoriesCount = sum;
  }

  updateAll(): void {
    this.categoriesList = this.categoriesList.map(item => {return { ...item, checked: !this.isAllChecked };});
    this.updateAllChecked();
  }

  toggleCategoriesDropdown(): void {
    this.responsivityService.changeIsCategoriesOpen(!this.isMobileCategoriesOpen);
  }

  emitSelectedCategories(): void {
    this.categoriesEmitter.emit(this.categoriesList);
    this.toggleCategoriesDropdown();
  }

  updateList(item: ICategoryItem): void {
    this.categoriesList.map(category => {
      if (category.id === item.id) {
        category.checked = !category.checked;
      }
    });
    this.updateAllChecked();
  }

  cancel(): void {
    this.toggleCategoriesDropdown();
    this.resetList();
  }
}
